<template>
  <b-modal scrollable v-model="isVisible">
    <template v-slot:modal-title>
      <b>Add From Media Library</b>
    </template>
    <div v-if="processing">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      Click images to select them
      <div v-for="(media, mediaIndex) in mediaLibrary" :key="mediaIndex">
        <MediaLibraryModalCard
          v-bind:selected="isSelectedMedia(mediaIndex)"
          v-on:selected="mediaSelected"
          v-bind:media="media"
        />
      </div>
    </div>
    <template v-slot:modal-footer>
      <button
        v-on:click="emitSelectedMedia"
        v-bind:disabled="selectedMedia == null"
        type="button"
        class="btn btn-success"
      >Add Selected Images</button>
    </template>
  </b-modal>
</template>

<script>
import MediaLibraryModalCard from "@/components/Admin/MediaLibraryModalCard.vue";
import api from "../../api/api";
export default {
  components: {
    MediaLibraryModalCard,
  },
  data: function () {
    return {
      processing: false,
      isVisible: false,
      selectedMedia: [],
      mediaLibrary: {},
    };
  },
  methods: {
    isSelectedMedia(id) {
        return this.selectedMedia.includes(id);
    },
    emitSelectedMedia() {
      if (this.selectedMedia.length != 0) {
          var eventdata = [];
          for(var i = 0; i < this.selectedMedia.length; i++)
          {
              eventdata.push(this.mediaLibrary[this.selectedMedia[i]]);
          }
          this.$emit("mediaSelected", eventdata);
          this.hide();
      }
      this.selectedMedia = [];
    },
    mediaSelected(id) {
      if(this.isSelectedMedia(id)) {
          this.selectedMedia.splice(this.selectedMedia.indexOf(id), 1); 
      } else {
          this.selectedMedia.push(id);
      }
    },
    show() {
      this.isVisible = true;
      this.processing = true;
      api
        .getMediaLibrary()
        .then((res) => {
          //Create dictionary from response
          for (var i = 0; i < res.media.length; i++) {
            this.$set(this.mediaLibrary, res.media[i].id, res.media[i]);
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
    hide() {
      this.isVisible = false;
      this.selectedMedia = null;
    },
  },
};
</script>